export const environment = {
  production: true,
  name_service: 'produccion',
    UGD_ID: 47,
    gaTrackingId: 'G-WVVDNPJS0R'

};
